import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { LuPlus } from "react-icons/lu";
import "../../../../src/TextFamily.css";
import "../DeshBoard.css";
import AddBankDetails from "../BankDetails/AddBankDetails";
import { Api } from "../../../services/httpService";
import { IoCheckmarkCircle } from "react-icons/io5";
import Loader from "../Loader";
import LoaderModal from "../LoaderModal";
import { HiOutlinePencil } from "react-icons/hi2";

function MyCompany(props) {

  const [title, setTitle] = useState(null);
  const [addDetails, setAddDetails] = useState(false);
  const [bankOverview, setBankOverview] = useState(false);
  const [loading, setLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [companyListForStatus, setCompanyListForStatus] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [merchantId, setMerchantId] = useState(null);
  const [show, setShow] = useState(false); // Possibly used for modal later
  const initialFormState = {
    accountNum: "",
    ibanNum: "",
    bankName: "",
    branchName: "",
    swiftCode: "",
  };
  const [formData, setFormData] = useState(initialFormState);

  const id = localStorage.getItem("_id");
  const fetchCompanyStatus = async () => {
    // setLoading(true);
    try {
      const response = await Api(
        "get",
        `/company/getCompanyListWithStatusBySection/${id}?sectionType=BANK`
      );

      if (response && response.body) {
        setCompanyListForStatus(response.body.companies);
        props?.triggerProgressRefresh();
      }
      //  setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchCompanies = async () => {
      setLoading(true);
      try {
        const response = await Api("get", `/company/companyList/${id}`);
       
        if (response && response.body) {
          setCompanyList(response.body);
          setLoading(false);
        } 
      } catch (error) {
        console.error(error);
      }
    };

    fetchCompanies();
    fetchCompanyStatus();
  }, [id, addDetails]);

  // Before your return, inside the map:
  const getCompanyStatusNode = (company) => {
    const com = companyListForStatus?.find(
      (item) => item?.companyId === company?.id
    );
    if (com?.sectionStatus === "SUBMITTED") {
      return (
        <div className="note-btn comp-btn w-100">
          <span>
            <IoCheckmarkCircle />
            Submitted
          </span>
        </div>
      );
    } else if (com?.sectionStatus === "IN_PROGRESS") {
      return (
        <div className="note-btn w-100 ">
          <span className="text-primary">In Progress</span>
        </div>
      );
    } else if (com?.sectionStatus === "NOT_STARTED") {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>
        </div>
      );
    }else if (com?.sectionStatus === "NEEDS_ATTENTION") {
      return (
        <div className="note-btn w-100">
          <span>Needs Attention</span>
        </div>
      );
    } else if (com?.sectionStatus === "UNDER_REVIEW") {
      return (
        <div className="note-btn w-100">
          <span>Under Review</span>
        </div>
      );
    } else if (com?.sectionStatus === "APPROVED") {
      return (
        <div className="note-btn w-100">
          <span className="text-success">Approved</span>
        </div>
      );
    } else if (com?.sectionStatus === "REJECTED") {
      return (
        <div className="note-btn w-100">
          <span style={{ fontSize: "16px", color: "#B22D2D" }}>Rejected</span>
        </div>
      );
    } else {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>
        </div>
      );
    }
  };
  const getButtonStatus = (company) => {
    const com = companyListForStatus?.find(
      (item) => item?.companyId === company?.id
    );
    if (com?.sectionStatus === null) {
      return (
        <Button
          className="d-flex align-items-center"
          variant="primary"
          onClick={() => {
            setTitle(company?.tradeName);
            setCompanyId(company?.id);
            setMerchantId(company?.merchantId);
            setAddDetails(true);
          }}
        >
          Start
          <span>
            <LuPlus />
          </span>
        </Button>
      );
    } else {
      return (
        <Button
          className="d-flex align-items-center"
          variant="primary"
          onClick={() => {
            setTitle(company?.tradeName);
            setCompanyId(company?.id);
            setMerchantId(company?.merchantId);
            setAddDetails(true);
          }}
        >
          Edit
          <HiOutlinePencil />
        </Button>
      );
    }
  };

  return (
    <>
      <div className="deshboard-content">
        <div className="dashboard-head ">
          <div className="container">
            <div className="company-list-content">
              <div className="row align-items-end">
                <div className="col-7">
                  <div className="breadcrumb-section mb-3">
                    {!addDetails && !bankOverview && (
                      <ul className="breadcrumb">
                        <li>Company List</li>
                      </ul>
                    )}

                    {addDetails && !bankOverview && (
                      <ul className="breadcrumb">
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setAddDetails(false);
                              setBankOverview(false);
                            }}
                          >
                            Company List
                          </a>
                        </li>
                        <li>Bank Accounts</li>
                      </ul>
                    )}

                    {addDetails && bankOverview && (
                      <ul className="breadcrumb">
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setAddDetails(false);
                              setBankOverview(false);
                              setTitle(null);
                            }}
                          >
                            Company List
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setAddDetails(true);
                              setBankOverview(false);
                              setFormData(initialFormState);
                            }}
                          >
                            Bank Accounts
                          </a>
                        </li>
                        <li>Bank Overview</li>
                      </ul>
                    )}
                  </div>

                  {!addDetails && !bankOverview && (
                    <div className="pb-4 mb-2">
                      <h1 className="company-title mb-2">My Companies</h1>
                      <p className="com-sub-title">
                        Tell us more about your company so we can tailor your
                        credit options
                      </p>
                    </div>
                  )}

                  {addDetails && (
                    <div className="deshborder-head-title">
                      <h2 className="company-title mb-4">{title}</h2>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {addDetails ? (
          <AddBankDetails
            setBankOverview={setBankOverview}
            bankOverview={bankOverview}
            addDetails={addDetails}
            setAddDetails={setAddDetails}
            companyId={companyId}
            merchantId={merchantId}
            title={title}
            formData={formData}
            setFormData={setFormData}
            triggerProgressRefresh={props?.triggerProgressRefresh}
          />
        ) : (
          <div className="company-info-box">
            <div className="container">
              <div className="row">
                {loading ? (
                  <div
                    className="col-12  "
                    // style={{ minHeight: "40vh" }}
                  >
                    <Loader />
                  </div>
                ) : (
                  companyList.length > 0 &&
                  companyList.map((company, index) => (
                    <div className="col-12" key={index}>
                      <div className="company-info-inner d-flex align-items-start flex-wrap p-3 mb-3">
                        <p className="info-title m-0">{company?.tradeName}</p>
                        <div className="info-start ms-auto">
                          {getButtonStatus(company)}
                        </div>
                        {getCompanyStatusNode(company)}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MyCompany;
